import type { Locale } from '@/intl/types'

export function formatDestination(destinationInformation?: {
  regionName?: string
  countryName?: string
  cityName?: string
}): string {
  if (!destinationInformation)
    return ''

  const { cityName = '', regionName = '', countryName = '' } = destinationInformation
  const segments = [cityName, regionName, countryName]
    .filter(part => part && part.trim())
  return segments.join(', ')
}

export function formatPeriod(departureDate: string, returnDate: string, locale: Locale = 'nl-NL'): string {
  const departure = new Date(departureDate)
  const returnD = new Date(returnDate)

  if (Number.isNaN(departure.getTime()) || Number.isNaN(returnD.getTime())) {
    return ''
  }

  const formatDate = (date: Date) => {
    return date.toLocaleDateString(locale, {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })
  }

  return `${formatDate(departure)} - ${formatDate(returnD)}`
}

export function isBookingCancelled(status: string): boolean {
  return status.toLowerCase() === 'cancelled'
}

export function isBookingPast(returnDate: string): boolean {
  if (!returnDate || typeof returnDate !== 'string') {
    return false
  }
  const returnD = new Date(returnDate)
  if (Number.isNaN(returnD.getTime())) {
    return false
  }
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return returnD < today
}

export function getOptimizedImageUrl(originalUrl: string, height: number = 160): string {
  if (!originalUrl.trim())
    return ''

  try {
    const url = new URL(originalUrl)
    url.searchParams.set('height', height.toString())
    return url.toString()
  }
  catch {
    return originalUrl
  }
}
